import { render, staticRenderFns } from "./PermanentBanButton.vue?vue&type=template&id=0a9c2d47&scoped=true&"
import script from "./PermanentBanButton.vue?vue&type=script&lang=js&"
export * from "./PermanentBanButton.vue?vue&type=script&lang=js&"
import style0 from "./PermanentBanButton.vue?vue&type=style&index=0&id=0a9c2d47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c2d47",
  null
  
)

export default component.exports